export default "__VITE_ASSET__dLcEWXnW__"